<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="SalesAdd"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start">
                    {{ $t("salesAdd") }}
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    ></div>

                    <div class="card">
                      <div class="card-body">
                        <h5 class="General"></h5>
                        <hr />
                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("salesNameTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <input
                              type="text"
                              class="form-control"
                              id="sales_name"
                              :placeholder="$t('salesNameTxt')"
                              v-model="forms.sales_name"
                              required
                            />
                            <div v-if="errors.sales_name">
                              <div
                                v-for="error in errors.sales_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <!-- <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("salesEmailTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-4">
                            <input
                              type="email"
                              class="form-control"
                              id="sales_email"
                              :placeholder="$t('salesEmailTxt')"
                              v-model="forms.sales_email"
                              required
                            />
                            <div v-if="errors.sales_email">
                              <div
                                v-for="error in errors.sales_email"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div> -->
                        </div>

                        

                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("statusTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <!-- <select
                              class="form-control"
                              name="company_id"
                              id="company_id"
                              v-model="forms.company_id"
                            >
                              <option
                                v-for="(a, index) of fetchCompany"
                                :value="a.company_id"
                                :key="index"
                              >
                                {{ a.code }} | {{ a.name }}
                              </option>
                            </select> -->

                            <v-select
                            
                              :options="statustype"
                              v-model="forms.status"
                              label="code"
                              return-object
                              @search="asyncSearchCompany"
                            ></v-select>

                        

                            <div v-if="errors.company_id">
                              <div
                                v-for="error in errors.company_id"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label"
                              >User Name</label
                            >
                          </div>
                          <div class="col-lg-4">
                            <v-select
                              :options="fetchUser"
                              v-model="users"
                              label="username"
                              return-object
                              @search="asyncSearchUser"
                            ></v-select>
                            <div v-if="errors.user_id">
                              <div
                                v-for="error in errors.user_id"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                         
                        </div>
                      </div>
                    </div>

                    <br />

                    <!-- <div class="row card">
                      <div class="card-header">
                        <h5 class="float-start">Sales Approval <span class="wajib">*</span></h5>

                        <button
                        class="
                          btn btn-success btn-icon
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="addField()"
                        type="button"
                      > <i class="link-icon" data-feather="plus"></i>
                      </button>
                        
                      </div> -->


                      <!-- <div class="card-body">
                        <div class="table-responsive">
                          <table
                            class="table table-hover"
                            style="height: 300px"
                          >
                            <thead>
                              <tr>
                                <th>#</th>
                                <th width="400px">Approval Name</th>
                                <th width="400px">Approval Email</th>
                                <th>Level</th>
                                
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(input, index) in this.detailAll"
                                :key="`phoneInput-${index}`"
                              >
                                <th>{{ index + 1 }}</th>
                                <td  width="400px"><input
                                    type="text"
                                    v-model="input.approval_name"
                                    class="form-control"
                                    style="width: 400px"
                                   
                                  /></td>
                                <td  width="400px"><input
                                    type="text"
                                    v-model="input.approval_email"
                                    class="form-control"
                                    style="width: 400px"
                                   
                                  /></td>
                                <td>
                                  <input
                                    type="number"
                                    v-model="input.level"
                                    class="form-control"
                                    style="width: 100px"
                                   
                                  />
                                </td>

                         
                                
                                <td>
                                

                            
                                  <svg
                                    
                                    @click="removeField(index, detailAll)"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    class="ml-2 cursor-pointer"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path
                                      fill="red"
                                      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
                                    />
                                  </svg>
                                </td>
                              </tr>
                            </tbody>

                            <tfoot></tfoot>
                          </table>
                        </div>
                      </div> -->
                    <!-- </div> -->
                  

                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from '@/middleware/mixinAddress.js';


export default {
  name: "SalesAdd",
  mixins: [myMixinAddress],
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      statustype :["Active","Non Active"],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
       fetchUser: [],
      // fetchCompanyNotLinc: [],
      // fetchRegion: [],
      // fetchSystemCode: [],
      errors: [],
      permision_role: [],
      userData: "",
      // companyCode: "",
       users: [],
     

      forms: {  },
      detailAll: [
       
       ],
    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.sales_name = "";
      this.forms.sales_email = "";
     // this.forms.status = "";
      this.status = [];

     
    },

    backForm() {
      window.location.href = "/sales";
    },

    // loadCompany() {
    //   const baseURI = this.$settings.endPoint + "company?limit=10";

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchCompany = response.data.datas.data;
    //   });
    // },

    addField() {
      //fieldType.push({ value: "" });
      this.detailAll.push({
          approval_email: "",
          approval_name:'',
          level: 0,
         
        })
    },

    removeField(index, fieldType) {
     
     
     fieldType.splice(index, 1);
   },

    loadCompanyNotLinc() {
      const baseURI =
        this.$settings.endPoint + `company/select`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company?code=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },

    asyncSearchCompanyNotLinc(ev) {
      const baseURI =
        this.$settings.endPoint +
        "company/select&code="+ev
        this.companyCode;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    asyncSearchRegion(ev) {
      const baseURI = this.$settings.endPoint + "region?region_code=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchRegion = response.data.datas.data;
      });
    },


    loadSystemCode() {
      const baseURI = this.$settings.endPoint + "system-code/select?system_code=LOCATION_TYPE";
      return this.$http.get(baseURI).then((response) => {
        this.fetchSystemCode = response.data.datas.data;
      });
    },

    asyncSearchSystemCode(ev) {
      const baseURI = this.$settings.endPoint + "system-code?system_code=LOCATION_TYPE&description=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchRegion = response.data.datas.data;
      });
    },

    loadUser() {
      const baseURI = this.$settings.endPoint + "user?limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchUser = response.data.datas.data;
     
      });
    },

    asyncSearchUser(ev) {
      const baseURI = this.$settings.endPoint + "user?username=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchUser = response.data.datas.data;
      });
    },
    

    loadRegion() {
      const baseURI = this.$settings.endPoint + "region?limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchRegion = response.data.datas.data;
      });
    },

    submitData() {
      // const items = [];
    
      // this.detailAll.forEach((item) => {
      //   const data = {
         
      //     approval_name: item.approval_name,
      //     approval_email: item.approval_email,
         
      //     level: item.level,
         
      //   };
      //   items.push(data);
      // });
    
      this.fade(true);
      this.forms.user_id = this.users.user_id;
      this.forms.email = this.users.email;
      // this.forms.sales_approval_detail = items;
     

      const baseURI = this.$settings.endPoint + "sales/create";
      this.$http
        .post(baseURI, this.forms)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            
            this.errors = [];
            //console.log(response.data.datas.user_id);
            var params = this.$onRandom(response.data.datas.sales_id);
            window.location.href =
              "/sales/detail/" + params + "?status=200&msg=Successfully";
            // this.success('Berhasil');
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      //this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "SalesController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
     
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
     this.loadUser();
   
    
  },
};
</script>
<style scoped>
</style>